// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___fnKHh","open":"open___2QylV","section":"section___3FrBQ"};